import React, { useEffect, useState, useContext } from "react";
// @ts-ignore
import Layout from "@components/layouts/Layout";
// @ts-ignore
import Seo from "@components/common/Seo";
import useSWR from "swr";
import axios from "axios";
import Loading from "./Loading";
// @ts-ignore
import Image from "@components/common/CloudinaryImage";
import { cn } from "../../../utils/cn";
import { MdAddShoppingCart } from "react-icons/md";
import useSound from "use-sound";
// @ts-ignore
import addToBasketSfx from "@static/sounds/addProduct.mp3";
// @ts-ignore
import { CartContext } from "@components/contexts/CartContext";
import { toast } from "react-toastify";
// import { GiBlackBook, GiSmartphone } from "react-icons/gi";
// import { GoPackageDependents } from "react-icons/go";
// import { MdOutlineLocalOffer, MdInfoOutline, MdEuroSymbol } from "react-icons/md";

// Fix para que funciona ReactJson
const ReactJsonView = typeof window !== `undefined` ? require("react-json-view").default : null;

const Component = ({
    item,
    title,
    children: contentData,
}: {
    item: any;
    title: string;
    // childs: any;
    children: React.ReactNode;
}) => {
    const [product, setProduct] = useState<any>(item);

    const { data, isLoading, isValidating } = useSWR("/.netlify/functions/products", axios.get, {
        dedupingInterval: 10 * 1000,
    });

    const loading = isLoading || isValidating;

    useEffect(() => {
        if (data) {
            // @ts-ignore
            const singleItem = data?.data?.products?.find((x: any) => x.id === item.id);

            // @ts-ignore
            const childs = data?.data?.products?.filter(
                (childItem: any) => singleItem.childs && singleItem.childs.includes(childItem.id),
            );

            // Actualizamos los datos del producto, por si se hubieran actualizado
            if (singleItem) {
                setProduct({
                    ...singleItem,
                    childs,
                });
            }
        }
    }, [data]);

    return (
        <Layout>
            <Seo
                title={product.title}
                description={product.description}
                image={`/images/products${product.images[0]}`}
            />
            <section className={styles.section}>
                <Loading loading={loading} />
                <RenderItemInfo item={product} data={contentData} title={title} />
            </section>
        </Layout>
    );
};

const RenderItemInfo = ({
    item,
    data,
    title,
}: {
    item: any;
    data: React.ReactNode;
    title?: string;
}) => {
    return (
        <>
            <div className="space-y-20">
                {/** Cabecera */}
                <div className="space-y-5">
                    <h1 className="text-center text-balance text-4xl font-extrabold leading-none tracking-tight text-gray-700 md:text-5xl lg:text-6xl dark:text-white">
                        {item.title}
                    </h1>

                    {item.description && (
                        <h2 className="text-center mb-6 text-lg font-normal text-gray-600 lg:text-xl sm:px-16 xl:px-48 dark:text-gray-400">
                            {item.description}
                        </h2>
                    )}
                </div>

                {/** Imagen */}
                <ItemImage item={item} />

                {/** Si hay stock */}
                {item.stock ? (
                    <>
                        {/** Precios */}
                        {item.childs?.length > 0 ? (
                            <PricesSection item={item} />
                        ) : (
                            !item.special_buy && <PriceSection item={item} />
                        )}
                    </>
                ) : (
                    <div className="flex items-center justify-center gap-2 rounded-full bg-purple-200 py-2 px-5 text-purple-800 text-sm">
                        {item.stock_message || "Sin estoc en este momento."}
                    </div>
                )}

                {/** Descripción y contenido */}
                <MoreInfo title={title}>{data}</MoreInfo>
            </div>

            <div className="text-xs text-right text-gray-500">REF: {item.id}</div>

            {process.env.NODE_ENV === "development" && (
                <ReactJsonView src={item} collapsed={true} />
            )}
        </>
    );
};

const ItemImage = ({ item }: { item: any }) => {
    const image = getImage(item);

    return <Image alt={item.name} filename={image} className={cn("rounded object-cover shadow")} />;
};

const getImage = (item: any) => {
    // Obtenemos la imagen por defecto del producto
    const images = item.images || [];

    // Si no hay imágenes, usamos una por defecto
    const defaultImage = images.length > 0 ? images[0] : "products/common/0";

    return defaultImage;
};

const PricesSection = ({ item }: { item: any }) => {
    return (
        <section className="py-5">
            <div className="space-y-2">
                <h2 className="text-base font-semibold leading-7 text-cpurple text-center">
                    Modalidades disponibles
                </h2>

                <p className="text-4xl font-bold tracking-tight text-gray-700 sm:text-5xl text-center">
                    Opciones para todo tipo de opositores
                </p>

                {item.multiple_languages && (
                    <p className="mx-auto max-w-2xl text-center text-lg leading-8 text-gray-600">
                        Además, te ofrecemos la posibilidad de realizar el curso en el{" "}
                        <strong>idioma que prefieras</strong>. Disponemos de
                        <strong>varias opciones lingüísticas</strong> para que puedas estudiar con
                        comodidad y sacar el máximo provecho al contenido. Solo tienes que{" "}
                        <strong>elegir el idioma</strong> que mejor se adapte a ti al iniciar el
                        curso.
                    </p>
                )}

                {item.multiple_plans && (
                    <p className="mx-auto max-w-2xl text-center text-lg leading-8 text-gray-600">
                        Elige el plan que mejor se adapte a tus necesidades y presupuesto. Cada plan
                        superior incluye
                        <strong>más beneficios</strong> y supone un{" "}
                        <strong>ahorro considerable</strong> a largo plazo, facilitando tu
                        preparación para la oposición de forma más completa y eficiente.
                    </p>
                )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-10 max-w-4xl mx-auto mt-10">
                {item?.childs?.map((child: any, index: number) => (
                    <PriceSectionItem key={index} item={child} />
                ))}
            </div>
        </section>
    );
};

const PriceSectionItem = ({ item }: { item: any }) => {
    const [play] = useSound(addToBasketSfx, { volume: 0.25 });

    // @ts-ignore
    const { addProduct } = useContext(CartContext);

    const units = item.items;
    const pricePerUnit = item.price / units;
    const price = item.price;
    const defaultInParent = item.default_in_parent;

    const formatter = new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const handleAddToCart = () => {
        addProduct(item);

        // Reproducimos el sonido de añadir al carrito
        play();

        // Añadimos el item al carrito
        toast.success("Producto añadido al carrito", {
            position: "bottom-center",
            closeOnClick: true,
            pauseOnHover: false,
            autoClose: 3000,
        });
    };

    return (
        <div
            className={cn(
                "border-2 rounded-2xl p-8 space-y-4 hover:border-ccyan duration-300 relative",
                defaultInParent && "border-cpurple",
            )}
        >
            {defaultInParent && (
                <div className="top-0 right-0 absolute rounded-tr-lg bg-cpurple px-3 rounded-bl-lg">
                    <span className="uppercase font-medium text-xs mt-6 text-white">
                        Más popular
                    </span>
                </div>
            )}

            <h1
                className={cn(
                    "font-bold text-gray-600 text-balance",
                    defaultInParent && "text-cpurple",
                )}
            >
                {item.title}
            </h1>

            {item.description && <h2 className="text-sm text-gray-700">{item.description}</h2>}

            <div>
                <span className="font-bold text-4xl text-gray-600">
                    {formatter.format(pricePerUnit)}
                </span>
                <span className="ml-2 text-gray-700 text-semibold text-sm">/ sesión</span>
            </div>

            <button
                onClick={handleAddToCart}
                disabled={!item.stock}
                className={
                    cn(
                        "border text-sm rounded-lg w-full py-3 duration-300 px-5 flex flex-row items-center justify-center gap-2",
                        defaultInParent
                            ? "text-white duration-300 border-cpurple bg-cpurple hover:bg-white hover:text-cpurple"
                            : "border-gray-400 hover:border-gray-600 text-gray-600",
                        !item.stock && "opacity-25 pointer-events-none",
                    )
                    // styles.button,
                    // "text-cpurple duration-300 border-cpurple hover:bg-cpurple text-sm",
                    // !item.stock && "opacity-25 pointer-events-none",
                }
                // onClick={handleAddToCart}
            >
                <MdAddShoppingCart className="w-6 h-6" />
                <span className="font-medium hidden md:inline">
                    Pagas <span className="font-bold">{formatter.format(price)}</span> por{" "}
                    <span className="font-bold">{units}</span> unidades
                </span>

                <span className="font-medium md:hidden">
                    Pagas <span className="font-bold">{formatter.format(price)}</span>
                </span>
            </button>
        </div>
    );
};

const PriceSection = ({ item }: { item: any }) => {
    const [play] = useSound(addToBasketSfx, { volume: 0.25 });

    // @ts-ignore
    const { addProduct } = useContext(CartContext);

    const offer = item.offer;
    const currentPrice = item.price;
    // const offerText = offer && item.offer_text;

    // const priceText = item.price_text || item.split_payment;
    const isOffer = offer && offer !== currentPrice && currentPrice < offer;

    /*const isBook = item.type === "book";
    const isApp = item?.app;
    const units = item?.items || 1;
    const lowStock = item.lowStock;*/

    const formatter = new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const handleAddToCart = () => {
        addProduct(item);

        // Reproducimos el sonido de añadir al carrito
        play();

        // Añadimos el item al carrito
        toast.success("Producto añadido al carrito", {
            position: "bottom-center",
            closeOnClick: true,
            pauseOnHover: false,
            autoClose: 3000,
        });
    };

    return (
        <section className="space-y-5 max-w-xl mx-auto">
            <div
                className={cn(
                    "border-2 rounded-2xl p-8 space-y-4 duration-300 relative border-cpurple",
                )}
            >
                <h1 className={cn("font-bold text-balance text-cpurple")}>{item.title}</h1>

                {item.description && <h2 className="text-sm text-gray-700">{item.description}</h2>}

                {!isOffer ? (
                    <div className="text-center">
                        <span className="font-bold text-4xl text-gray-800">
                            {formatter.format(currentPrice)}
                        </span>
                    </div>
                ) : (
                    <div className="flex flex-row gap-2 items-baseline justify-center">
                        <span className="font-bold text-2xl text-gray-500 line-through">
                            {formatter.format(offer)}
                        </span>

                        <span className="font-bold text-4xl text-gray-800">
                            {formatter.format(currentPrice)}
                        </span>
                    </div>
                )}

                <button
                    onClick={handleAddToCart}
                    disabled={!item.stock}
                    className={cn(styles.buyButton)}
                >
                    <MdAddShoppingCart className="w-6 h-6" />
                    <span className="font-medium text-lg">
                        Pagar <span className="font-bold">{formatter.format(currentPrice)}</span>
                    </span>
                </button>
            </div>
        </section>
    );
};

const MoreInfo = ({ children, title }: { children?: React.ReactNode; title?: string }) => {
    if (!children) {
        return <></>;
    }

    return (
        <section className="text-gray-700 mx-auto max-w-4xl">
            <div className="space-y-2">
                <h2 className="text-base font-semibold leading-7 text-cpurple text-center">
                    Más información
                </h2>

                {title && (
                    <p className="text-4xl font-bold tracking-tight text-gray-700 sm:text-5xl text-center">
                        {title}
                    </p>
                )}
            </div>

            <div className="mt-10 space-y-5 leading-8 text-center mx-auto text-gray-600">
                {children}
            </div>
        </section>
    );
};

const styles = {
    section: "container lg:px-0 py-10 space-y-10",
    buyButton:
        "border text-sm rounded-lg w-full py-3 px-5 flex flex-row items-center justify-center gap-2 text-white duration-300 border-cpurple bg-cpurple hover:bg-white hover:text-cpurple",
};

export default Component;
